import { HowDidYouObtainLecBrochureInput } from '../../lib/types/models/how-did-you-obtain-lec-brochures/how-did-you-obtain-lec-brochure-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function updateHowDidYouObtainLecBrochure(
  data: UpdateInput<HowDidYouObtainLecBrochureInput>
) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.howDidYouObtainLECBrochure.update.url, { id }))
    .patch(rest)
}
